import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAddress } from '@care-portals/api-interfaces';
import * as CheckoutActions from './checkout.actions';
import * as fromCheckout from './checkout.reducers';
import * as CheckoutSelectors from './checkout.selectors';

@Injectable()
export class CheckoutFacadeV2 {
  loading$ = this.store.select(CheckoutSelectors.selectLoading);
  orderId$ = this.store.select(CheckoutSelectors.selectOrderId);
  error$ = this.store.select(CheckoutSelectors.selectError);
  addresses$ = this.store.select(CheckoutSelectors.selectAddresses);
  cart$ = this.store.select(CheckoutSelectors.selectCart);
  coupon$ = this.store.select(CheckoutSelectors.selectCoupon);
  cvv$ = this.store.select(CheckoutSelectors.selectCvv);

  constructor(private store: Store<fromCheckout.State>) {}

  loadCart(cartId: string) {
    this.store.dispatch(CheckoutActions.loadCart({ cartId }));
  }

  reloadCart() {
    this.store.dispatch(CheckoutActions.reloadCart());
  }

  startCheckout(cartId: string) {
    this.store.dispatch(CheckoutActions.startCheckout({ cartId }));
  }

  finalizeCheckout(
    cartId: string,
    gateway: 'stripe' | 'nmi',
    couponCode: string
  ) {
    this.store.dispatch(
      CheckoutActions.finalizeCheckout({
        cartId,
        gateway,
        couponCode
      })
    );
  }

  loadAddresses() {
    this.store.dispatch(CheckoutActions.loadAddresses());
  }

  setSelectedAddressIndex(selectedAddressIndex: number | 'new') {
    this.store.dispatch(
      CheckoutActions.setSelectedAddressIndex({ selectedAddressIndex })
    );
  }

  setNewAddress(address: IAddress) {
    this.store.dispatch(CheckoutActions.setNewAddress({ address }));
  }

  addAddress(address: IAddress) {
    this.store.dispatch(CheckoutActions.addAddress({ address }));
  }

  applyCoupon(code: string) {
    return this.store.dispatch(CheckoutActions.applyCoupon({ code }));
  }

  setShippingAddress(cartId: string, address: IAddress) {
    return this.store.dispatch(
      CheckoutActions.setShippingAddress({ cartId, address })
    );
  }

  setSelectedPaymentMethod(paymentMethodId: string) {
    this.store.dispatch(
      CheckoutActions.setSelectedPaymentMethod({ paymentMethodId })
    );
  }

  setCvv(value: string, showError: boolean) {
    this.store.dispatch(CheckoutActions.setCvv({ value, showError }));
  }
}
